module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/BattleTitleTooltip/images/reward-icon.8a0149fe.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/BattleTitleTooltip/images/reward-icon.png
// module id = 2506
// module chunks = 11